import styles from './Navigation.module.css'

interface NavigationProps {
  title?: string
  subTitle?: string
  showBack?: boolean
  onBack?: () => void
}

const Navigation = ({ title = '资源中心', subTitle = 'news.antom.com', showBack = false, onBack }: NavigationProps) => {
  return (
    <div className={styles.nav}>
      <div className={styles.backButton} onClick={onBack} style={{ visibility: showBack ? 'visible' : 'hidden' }}>
        <svg viewBox="0 0 24 24" className={styles.arrow}>
          <path d="M8 5l5 7-5 7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <div className={styles.title}>
        <span className={styles.mainTitle}>{title}</span>
        <span className={styles.subTitle}>{subTitle}</span>
      </div>
      <div className={styles.moreButton}>
        <svg viewBox="0 0 22 22" className={styles.moreIcon}>
          <circle cx="5" cy="11" r="1.5" fill="currentColor"/>
          <circle cx="11" cy="11" r="1.5" fill="currentColor"/>
          <circle cx="17" cy="11" r="1.5" fill="currentColor"/>
        </svg>
      </div>
    </div>
  )
}

export default Navigation
